// src/components/Navbar.js
import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { FaChevronDown } from "react-icons/fa";
import UserMenu from "./UserMenu";
import NotificacionesBell from "./NotificacionesBell";

export default function Navbar() {
  const { modulos } = useContext(AuthContext);
  const location = useLocation();

  // 🔹 Ajustar rutas
  const getRuta = (ruta) => {
    if (!ruta) return "/dashboard";
    return ruta === "/dashboard" ? "/dashboard" : `/dashboard${ruta}`;
  };

  return (
    <nav className="bg-white border-b border-slate-200 px-6 py-2.5 flex justify-between items-center shadow-sm">

      {/* MENÚ PRINCIPAL */}
      <div className="flex gap-1 items-center">

        {modulos.map((modulo) => {
          const ruta = getRuta(modulo.ruta);
          const activo = location.pathname === ruta;

          return (
            <div
              key={modulo.id_modulo || modulo.nombre}
              className="relative group"
            >

              {/* BOTÓN PRINCIPAL */}
              <Link
                to={ruta}
                className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition ${
                  activo
                    ? "bg-indigo-50 text-indigo-600"
                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                }`}
              >
                {modulo.nombre}

                {modulo.submodulos && modulo.submodulos.length > 0 && (
                  <FaChevronDown className="text-xs opacity-60" />
                )}
              </Link>

              {/* SUBMENÚ */}
              {modulo.submodulos && modulo.submodulos.length > 0 && (
                <div
                  className="
                  absolute left-0 top-full
                  hidden group-hover:block hover:block
                  bg-white text-slate-700
                  border border-slate-200
                  rounded-lg shadow-lg
                  min-w-[200px]
                  py-2
                  z-50
                  "
                >

                  {modulo.submodulos.map((sub) => (
                    <Link
                      key={sub.id_modulo || sub.nombre}
                      to={getRuta(sub.ruta)}
                      className="
                      block px-4 py-2 text-sm
                      hover:bg-slate-50
                      hover:text-indigo-600
                      transition
                      "
                    >
                      {sub.nombre}
                    </Link>
                  ))}

                </div>
              )}

            </div>
          );
        })}

      </div>

      {/* USUARIO */}
      <div className="flex items-center gap-2">
        <NotificacionesBell />
        <UserMenu />
      </div>

    </nav>
  );
}
